// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vp-8";
export var editMode = "_vp-3";
export var headerRow = "_vp-a";
export var headerTitle = "_vp-b";
export var product = "_vp-1";
export var productDetails = "_vp-5";
export var productDivider = "_vp-7";
export var productImage = "_vp-2";
export var productInfo = "_vp-4";
export var productTitle = "_vp-6";
export var strikethrough = "_vp-9";
export var upsellProductsCard = "_vp-0";